import React, { useCallback, useState } from 'react';

const InlineEdit = ({
  value,
  onChange,
  fieldName,
  isEditing: isEditingProp,
  onSetIsEditing,
  readOnly,
}) => {
  const [isEditingInternal, setIsEditingInternal] = useState(false);

  const isEditing = isEditingProp !== undefined ? isEditingProp : isEditingInternal;
  const setIsEditing = onSetIsEditing || setIsEditingInternal;

  const [text, setText] = useState(value);

  const handleClick = useCallback(() => {
    if (readOnly) return;
    setIsEditing(true);
  }, [readOnly, setIsEditing]);

  const handleChange = useCallback(e => {
    setText(e.target.value);
  }, []);

  const handleBlur = useCallback(() => {
    setIsEditing(false);
    if (onChange && text !== value) {
      onChange({
        target: {
          value: text,
          name: fieldName,
        },
      });
    }
  }, [onChange, text, value, fieldName, setIsEditing]);

  const handleKeyDown = useCallback(e => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      e.target.blur();
    }
  }, []);

  if (isEditing && !readOnly) {
    return (
      <textarea
        type="text"
        value={text}
        onChange={handleChange}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        autoFocus
        className="w-full border-b"
        style={{ padding: 5 }}
      />
    );
  }

  return (
    <div onClick={handleClick} className="w-full" style={{ padding: 5, minHeight: 38 }}>
      {value || (readOnly ? '' : 'Click to edit')}
    </div>
  );
};

export default InlineEdit;
